var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedMarkerPvr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21534_12205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6754 40.7136L22 40.9908L22.3246 40.7136C27.2299 36.5262 30.9323 32.6067 33.4115 28.9517C35.8896 25.2985 37.1667 21.8781 37.1667 18.7C37.1667 9.27858 29.9606 3.16669 22 3.16669C14.0394 3.16669 6.83334 9.27858 6.83334 18.7C6.83334 21.8781 8.11041 25.2985 10.5885 28.9517C13.0677 32.6067 16.7701 36.5262 21.6754 40.7136Z",
    fill: "#FFCB05",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 26.75V13.25H17.5V14.75H19V13.25H25V14.75H26.5V13.25H28V26.75H26.5V25.25H25V26.75H19V25.25H17.5V26.75H16ZM17.5 23.75H19V22.25H17.5V23.75ZM17.5 20.75H19V19.25H17.5V20.75ZM17.5 17.75H19V16.25H17.5V17.75ZM25 23.75H26.5V22.25H25V23.75ZM25 20.75H26.5V19.25H25V20.75ZM25 17.75H26.5V16.25H25V17.75ZM20.5 25.25H23.5V14.75H20.5V25.25Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21534_12205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedMarkerPvr);
export default __webpack_public_path__ + "static/media/selected-marker-pvr.c892156134983067565e100d747b1b95.svg";
export { ForwardRef as ReactComponent };